(function () {
  'use strict';
  var logic = window.ZimorGiftLogic;
  if (!logic) return;

  document.querySelectorAll('[data-zimor-gift-root]').forEach(function (root) {
    if (root.dataset.zimorReady === 'true') return;
    root.dataset.zimorReady = 'true';

    var dialog = root.querySelector('[data-zimor-gift-dialog]');
    var submit = root.querySelector('[data-zimor-submit]');
    var remaining = root.querySelector('[data-zimor-remaining]');
    var error = root.querySelector('[data-zimor-error]');
    var customToggle = root.querySelector('[data-zimor-custom-toggle]');
    var customFields = root.querySelector('[data-zimor-custom-fields]');
    var customError = root.querySelector('[data-zimor-build-error]');
    var options = Array.from(root.querySelectorAll('[data-zimor-variant]')).map(function (row) {
      return {
        id: row.dataset.zimorVariant,
        available: row.dataset.available === 'true',
        count: 0,
        row: row,
        countElement: row.querySelector('[data-zimor-count]'),
        decrease: row.querySelector('[data-zimor-decrease]'),
        increase: row.querySelector('[data-zimor-increase]')
      };
    });
    var pending = null;
    var submitting = false;
    var addedToCart = false;
    var showRetry = false;
    var watchVariants = root.dataset.watchVariants.split(',');

    if (customToggle) {
      customToggle.addEventListener('change', function () {
        customFields.hidden = !customToggle.checked;
        customToggle.setAttribute('aria-expanded', String(customToggle.checked));
        customError.textContent = '';
        if (customToggle.checked) root.querySelector('[data-zimor-dial]').focus();
      });
    }

    function update() {
      var selected = logic.sumCounts(options);
      var needed = pending ? pending.quantity - selected : 0;
      options.forEach(function (option) {
        option.countElement.textContent = String(option.count);
        option.decrease.disabled = option.count === 0 || submitting;
        option.increase.disabled = !option.available || needed <= 0 || submitting;
      });
      remaining.textContent = submitting ? 'Preparing your checkout…' : (pending ? (needed === 0 ? 'Your gifts are ready.' : needed + ' bracelet' + (needed === 1 ? '' : 's') + ' left to choose') : '');
      submit.disabled = submitting || (!addedToCart && (!pending || needed !== 0));
      submit.textContent = addedToCart ? 'Review your bag' : 'Try again';
      submit.style.display = showRetry && needed === 0 && !submitting ? 'block' : 'none';
    }

    function isProductForm(form) {
      try {
        if (!form || !/\/cart\/add\/?$/.test(new URL(form.action, window.location.href).pathname)) return false;
        var id = new FormData(form).get('id');
        return watchVariants.includes(String(id));
      }
      catch (_) { return false; }
    }

    function readPurchase(form) {
      var data = new FormData(form);
      var id = data.get('id') || root.dataset.defaultVariant;
      var quantity = logic.parseQuantity(data.get('quantity') || 1);
      if (!/^\d+$/.test(String(id)) || !quantity) throw new Error('Please choose a watch variant and quantity.');
      var properties = {};
      if (customToggle && customToggle.checked) {
        var dial = root.querySelector('[data-zimor-dial]').value.trim();
        var band = root.querySelector('[data-zimor-band]').value.trim();
        var notes = root.querySelector('[data-zimor-build-notes]').value.trim();
        if (!dial && !band) {
          root.querySelector('[data-zimor-dial]').focus();
          throw new Error('Please describe the dial, the band, or both for your custom watch.');
        }
        if (dial) properties['Dial request'] = dial;
        if (band) properties['Band request'] = band;
        if (notes) properties['Build notes'] = notes;
      }
      return { id: id, quantity: quantity, properties: properties };
    }

    function openFor(form) {
      if (addedToCart) { window.location.assign(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'cart'); return; }
      try { pending = readPurchase(form); error.textContent = ''; if (customError) customError.textContent = ''; }
      catch (problem) { if (customError) customError.textContent = problem.message; else error.textContent = problem.message; return; }
      options.forEach(function (option) { option.count = 0; });
      showRetry = false;
      update();
      if (!dialog.open) dialog.showModal();
      var firstAvailable = root.querySelector('[data-zimor-increase]:not(:disabled)');
      if (firstAvailable) firstAvailable.focus();
      if (!options.some(function (option) { return option.available; })) error.textContent = 'The bracelets are currently unavailable. Please try again later.';
    }

    // Intercept before theme scripts submit via Ajax. Only the product form's
    // ordinary add button is intercepted; dynamic checkout is disabled separately.
    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : event.target.parentElement;
      var button = target && target.closest('button[type="submit"],button[name="add"],input[type="submit"]');
      var form = button && button.closest('form');
      if (!button || !isProductForm(form) || button.closest('.shopify-payment-button')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openFor(form);
    }, true);

    document.addEventListener('submit', function (event) {
      if (!isProductForm(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!dialog.open) openFor(event.target);
    }, true);

    options.forEach(function (option) {
      option.increase.addEventListener('click', function () {
        if (pending && option.available && !submitting && logic.sumCounts(options) < pending.quantity) {
          option.count += 1;
          update();
          if (logic.sumCounts(options) === pending.quantity) submit.click();
        }
      });
      option.decrease.addEventListener('click', function () {
        if (option.count > 0) { option.count -= 1; update(); }
      });
    });

    root.querySelector('[data-zimor-close]').addEventListener('click', function () { if (!submitting) dialog.close(); });
    dialog.addEventListener('cancel', function (event) { if (submitting) event.preventDefault(); });

    async function removeOfferGifts(cart, offerToken, base) {
      // The private property isolates this attempt from gifts already in the bag.
      // Shopify can split a discounted variant across several cart lines.
      for (var attempt = 0; attempt < 10; attempt += 1) {
        var line = cart.items.find(function (item) {
          return item.properties && item.properties._zimor_offer === offerToken;
        });
        if (!line) return true;
        var changed = await fetch(base + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
        if (!changed.ok) return false;
        cart = await changed.json();
      }
      return false;
    }

    submit.addEventListener('click', async function () {
      if (addedToCart) { window.location.assign(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'cart'); return; }
      if (submitting || !pending) return;
      var items;
      try { items = logic.buildItems(pending.id, pending.quantity, options); }
      catch (problem) { error.textContent = problem.message; showRetry = true; update(); return; }
      if (Object.keys(pending.properties).length) items[0].properties = pending.properties;
      var offerToken = Date.now().toString(36) + Math.random().toString(36).slice(2);
      items.slice(1).forEach(function (item) { item.properties = { _zimor_offer: offerToken }; });
      submitting = true;
      error.textContent = '';
      update();
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      base = base.replace(/\/?$/, '/');
      try {
        var added = await fetch(base + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var response = await added.json().catch(function () { return {}; });
        if (!added.ok) throw new Error(response.description || response.message || 'Could not add your selection. Please try again.');
        addedToCart = true;
        var checked = await fetch(base + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' });
        if (!checked.ok) throw new Error('Could not confirm your cart. Please review your bag before checkout.');
        var cart = await checked.json();
        var giftIds = items.slice(1).map(function (item) { return item.id; });
        if (!logic.giftsAreFree(cart, giftIds, offerToken)) {
          var removed = await removeOfferGifts(cart, offerToken, base);
          throw new Error(removed
            ? 'The complimentary discount is not active. The bracelet was removed; your watch is in the bag. Please review it before checkout.'
            : 'The complimentary discount is not active. Please review your bag before checkout.');
        }
        window.location.assign(base + 'checkout');
      } catch (problem) {
        error.textContent = problem.message || 'Something went wrong. Please try again.';
        submitting = false;
        showRetry = true;
        update();
      }
    });
    update();
  });
})();
